import { trackEventsViaInternalApi } from '@gonfalon/analytics/trackEventsViaInternalApi';
import type { PlanTypes } from '@gonfalon/billing/types';

export type ContactUsAnalyticAttributes = {
  component?: string;
  description?: string;
  path?: string;
  url?: string;
  type?: string;
  cta?: string;
  planType?: PlanTypes;
};

const trackContactUs = (event: string, attrs: ContactUsAnalyticAttributes = {}) => {
  const properties: Record<string, string> = {
    url: window.location.href,
    path: window.location.pathname,
  };
  for (const [key, value] of Object.entries(attrs)) {
    if (value !== undefined) {
      properties[key] = String(value);
    }
  }
  trackEventsViaInternalApi(event, properties).catch((err) => {
    // oxlint-disable-next-line no-console
    console.warn('Contact Us tracking via proxy failed', err);
  });
};

export const trackContactSalesLinkClicked = (analyticsAttributes?: ContactUsAnalyticAttributes) =>
  trackContactUs('Contact Us Clicked', { ...analyticsAttributes });

export const trackContactSalesFormSubmitted = (attr: ContactUsAnalyticAttributes) =>
  trackContactUs('Contact Us Form Submitted', attr);
